import React, { Fragment, useState } from "react";
import moment from "moment-hijri";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "تحويل التاريخ من هجري إلى ميلادي";
const DESCRIPTION =
  "تحويل التاريخ من هجري إلى ميلادي عن طريق إدخال التاريخ بالهجري ومعرفة الموافق له بالتاريخ الميلادي بواسطة محول التاريخ الإلكتروني";
const KEYWORDS =
  " هجري، ميلادي، أم القرى، شهر، محرم، صفر، رمضان، شوال، ذو الحجة، ذو القعدة، شعبان رجب صفر، عاشورا، ربيع أول، ربيع ثاني، يناير، فبراير، ديسمبر، مارس، ربيع، شتاء، صيف،تحويل التاريخ، من هجري الى ميلادي، من ميلادي الى هجري، تقويم أم القرى، التقويم الهجري، التقويم الإسلامي، التقويم الميلادي، الأشهر الهجرية، أوقات الصلاة";
const OG_URL = "https://do-calculate.com/calculator/ar/hijri_to_gregorian";

const HIJRI_MONTHS = [
  "مُحَرَّم",
  "صَفَر",
  "ربيع الأول",
  "ربيع الثاني",
  "جُمادى الأولى",
  "جُمادى الثانية",
  "رجب",
  "شعبان",
  "رمضان",
  "شوال",
  "ذو القعدة",
  "ذو الحجة",
];

function ConversionToGregorian() {
  const [hijriYear, setHijriYear] = useState("");
  const [hijriMonth, setHijriMonth] = useState("1");
  const [hijriDay, setHijriDay] = useState("1");
  const [gregorianDate, setGregorianDate] = useState("");
  const [showError, setShowError] = useState(false);

  const convertToGregorian = () => {
    if (!hijriYear) {
      setShowError(true);
      return;
    }

    const hijriStr = `${hijriYear}-${hijriMonth}-${hijriDay}`;
    const isValidDate = moment(hijriStr, "iYYYY-iM-iD", true).isValid();

    if (isValidDate && parseInt(hijriYear) > 1357) {
      const convertedDate = moment(hijriStr, "iYYYY-iM-iD").format("YYYY-M-D");
      setGregorianDate(convertedDate);
      setShowError(false);
    } else {
      setGregorianDate("");
      setShowError(true);
    }
  };

  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row p-3">
              <div>
                <p>
                  هذه الحاسبة عبر الإنترنت تُقدم وسيلة سهلة لتحويل التواريخ من
                  التقويم الهجري إلى الميلادي. يُتيح للمستخدم ببساطة تحديد اتجاه
                  التحويل وإدخال التاريخ الهجري الذي يرغب في تحويله. بعد ذلك،
                  تقوم الحاسبة بتنفيذ العملية تلقائيًا وتقديم التاريخ المحول
                  بالتقويم الميلادي. تُظهر النتيجة بتنسيق رقمي وتُقدم اليوم
                  والشهر والسنة بشكل مفصل. توفر هذه الحاسبة للمستخدمين فرصة
                  الحصول بسرعة وبدقة على التواريخ المحولة بين التقاويم الهجري
                  والميلادي، مما يُسهل تنظيم الأوقات والأحداث في الحياة اليومية.
                </p>
                <br />
                <p>
                  يُمكنك، من خلال هذه الحاسبة، إدخال التاريخ بصيغة هجرية، وستقوم
                  بعملية تحويل التاريخ المُدخل إلى ما يقابله في التاريخ الميلادي
                  العربي حسب تقويم أم القرى.
                </p>
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle p-3">
              <div className="p-3 mb-3 bg-success text-white">
                حاسبة تحويل التاريخ من هجري الى ميلادي
              </div>

              <label style={{ fontSize: "18px", fontWeight: "bold" }}>
                أدخل التاريخ الهجري
              </label>

              {/* Three Inputs in One Row */}
              <div className="row mt-3">
                <div className="col-md-4">
                  <label  style={{ fontSize: "14px" }}>اليوم</label>
                  <select
                    className="form-control"
                    value={hijriDay}
                    onChange={(e) => { setHijriDay(e.target.value); setGregorianDate(""); }}
                    style={{ fontSize: "16px", padding: "10px" }}
                  >
                    {Array.from({ length: 30 }, (_, i) => i + 1).map((day) => (
                      <option key={day} value={day}>{day}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label  style={{ fontSize: "14px" }}>الشهر</label>
                  <select
                    className="form-control"
                    value={hijriMonth}
                    onChange={(e) => { setHijriMonth(e.target.value); setGregorianDate(""); }}
                    style={{ fontSize: "16px", padding: "10px" }}
                  >
                    {HIJRI_MONTHS.map((month, index) => (
                      <option key={index} value={index + 1}>
                        {index + 1} - {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label  style={{ fontSize: "14px" }}>السنة</label>
                  <select
                    className="form-control"
                    value={hijriYear}
                    onChange={(e) => { setHijriYear(e.target.value); setGregorianDate(""); }}
                    style={{ fontSize: "16px", padding: "10px" }}
                  >
                    <option value="">السنة</option>
                    {Array.from({ length: 1471 - 1358 }, (_, i) => 1470 - i).map((year) => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="text-center mt-3">
                <button
                  className="btn btn-success"
                  onClick={convertToGregorian}
                  style={{ fontSize: "17px", padding: "10px 40px", marginTop: "10px" }}
                >
                  احسب
                </button>
              </div>

              {showError && (
                <p className="text-danger text-center mt-3">
                  الرجاء إدخال تاريخ صحيح بين 1358هـ والتاريخ الحالي
                </p>
              )}

              {gregorianDate && !showError && (
                <div className="mt-4">
                  <hr />
                  <div className="table-responsive">
                    <table className="table table-bordered text-center">
                      <thead className="bg-success text-white">
                        <tr>
                          <th style={{ fontSize: "20px", fontWeight: "normal" }}>التاريخ المدخل (هجري)</th>
                          <th style={{ fontSize: "20px", fontWeight: "normal" }}>يوافق بالتاريخ الميلادي</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ fontSize: "18px" }}>{`${hijriYear}-${hijriMonth}-${hijriDay}`}</td>
                          <td style={{ fontSize: "18px" }}>{gregorianDate}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <hr />
            </div>
          </div>

          <div className="row">
            <RelatedLinks />
            <br />
            <hr />
          </div>
        </div>

        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>

      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                تحويل التاريخ الميلادي إلى هجري
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>تحويل التاريخ الميلادي إلى هجري عبر الإنترنت</h2>
                </u>
                <br />
                <p>
                  استخدم الحاسبة عبر الإنترنت كوسيلة فعالة لتحويل التواريخ من
                  التقويم الميلادي إلى الهجري... [Rest of the original text preserved]
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>خطوات تحويل التاريخ</h2>
                </u>
                <br />
                <p>
                  استخدم محول التاريخ من هجري إلى ميلادي بسهولة. قم بتحديد اتجاه
                  التحويل، اختر اليوم والشهر والسنة، ثم قم بتحويله...
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>تطبيق عملي ومثال لتحويل التواريخ</h2>
                </u>
                <br />
                <p>
                  يقدم التطبيق مثال عملي لتحويل تاريخ ميلاد شخص ولد في دولة أجنبية بتاريخ 15/9/2020...
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>فوائد تحويل التواريخ</h2>
                </u>
                <br />
                <p>
                  تقدم هذه الحاسبة العديد من الفوائد، حيث يمكنك استخدامها لتحويل
                  تواريخ الأحداث الخاصة بك أو حتى تواريخ المستندات الرسمية...
                </p>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}

export default ConversionToGregorian;